<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <v-footer height="auto" class="white pa-3 app--footer">
            <span class="caption"
              >Jaque SAI &copy; {{ new Date().getFullYear() }}</span
            >
            <v-spacer></v-spacer>
            <span class="caption mr-1"> Realizado con amor </span>
            <v-icon color="pink" small>favorite</v-icon>
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- theme setting -->
        <!-- <v-btn small fab dark falt fixed top="top" right="right" class="setting-fab" color="red" @click="openThemeSettings">
          <v-icon>settings</v-icon>
        </v-btn> -->
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        >
          <theme-settings></theme-settings>
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>

    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-snackbar
      center
      top
      color="red"
      :multi-line="true"
      v-model="$store.state.notificacionCorteCaja"
    >
      <b>
        Se requiere realizar el corte de caja de tu sucursal, por favor realiza
        el corte de caja en cuanto te sea posible.</b
      >
      <v-btn
        dark
        flat
        @click.native="$store.state.notificacionCorteCaja = false"
        icon
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="$store.state.notificacionCorteCaja" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          CORTE DE CAJA
        </v-card-title>

        <v-card-text>
          Se requiere realizar el corte de caja de tu sucursal, por favor
          realiza el corte de caja en cuanto te sea posible.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$store.state.notificacionCorteCaja = false"
          >
            Aceptar
          </v-btn>
          <v-btn
            color="danger"
            text
            @click="$store.state.notificacionCorteCaja = false"
          >
            Realizar Corte
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import ThemeSettings from "@/components/ThemeSettings";
import AppEvents from "./event";

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings,
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "¡Bienvenido!",
      color: "",
    },
    dialogCorteCaja: false,
  }),
  watch: {
    $route(to, from) {
      this.operationReset();
    },
  },
  computed: {},

  created() {
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
  },
};
</script>

<style lang="stylus" scoped>
.setting-fab
  top:50%!important;
  right:0;
  border-radius:0
.page-wrapper
  min-height:calc(100vh - 64px - 50px - 81px );
</style>
